import { render, staticRenderFns } from "./BaseUploadFileNew.vue?vue&type=template&id=078df950&"
import script from "./BaseUploadFileNew.vue?vue&type=script&lang=js&"
export * from "./BaseUploadFileNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports